import { AxiosRequestConfig } from 'axios';

const endpoint = '/api/retrieval';

export default {
    getData: (data: Array<any>) => ({ method: 'POST', url: `${endpoint}/visualisation`, data } as AxiosRequestConfig),
};
